import { render } from "./propagandaPage.vue?vue&type=template&id=2490347f&scoped=true"
import script from "./propagandaPage.vue?vue&type=script&lang=js"
export * from "./propagandaPage.vue?vue&type=script&lang=js"

import "./propagandaPage.vue?vue&type=style&index=0&id=2490347f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2490347f"

export default script